"use strict";
import { __exports as u } from "./index.es333.js";
import { __require as P } from "./index.es334.js";
import { __require as g } from "./index.es335.js";
var m;
function z() {
  return m ? u : (m = 1, (function(c) {
    Object.defineProperty(c, "__esModule", {
      value: !0
    });
    function p(e, t) {
      for (var r in t) Object.defineProperty(e, r, {
        enumerable: !0,
        get: t[r]
      });
    }
    p(c, {
      safeCompile: function() {
        return l;
      },
      safePathToRegexp: function() {
        return h;
      },
      safeRegexpToFunction: function() {
        return R;
      },
      safeRouteMatcher: function() {
        return d;
      }
    });
    const o = P(), a = g();
    function h(e, t, r) {
      if (typeof e != "string")
        return (0, o.pathToRegexp)(e, t, r);
      const i = (0, a.hasAdjacentParameterIssues)(e), n = i ? (0, a.normalizeAdjacentParameters)(e) : e;
      try {
        return (0, o.pathToRegexp)(n, t, r);
      } catch (s) {
        if (!i)
          try {
            const f = (0, a.normalizeAdjacentParameters)(e);
            return (0, o.pathToRegexp)(f, t, r);
          } catch {
            throw s;
          }
        throw s;
      }
    }
    function l(e, t) {
      const r = (0, a.hasAdjacentParameterIssues)(e), i = r ? (0, a.normalizeAdjacentParameters)(e) : e;
      try {
        return (0, o.compile)(i, t);
      } catch (n) {
        if (!r)
          try {
            const s = (0, a.normalizeAdjacentParameters)(e);
            return (0, o.compile)(s, t);
          } catch {
            throw n;
          }
        throw n;
      }
    }
    function R(e, t) {
      const r = (0, o.regexpToFunction)(e, t || []);
      return (i) => {
        const n = r(i);
        return n ? {
          ...n,
          params: (0, a.stripParameterSeparators)(n.params)
        } : !1;
      };
    }
    function d(e) {
      return (t) => {
        const r = e(t);
        return r ? (0, a.stripParameterSeparators)(r) : !1;
      };
    }
  })(u), u);
}
export {
  z as __require
};
//# sourceMappingURL=index.es317.js.map
